Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart-widget');
    $wrapper.attr('data-template', '1');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var openWidget = false; //TODO: REMOVE

    var model = null;

    wrapper.open = function (userTriggeredOpen) {
        $(".js-widget-trigger", $wrapper).addClass('x-open');
        $(".js-widget-container", $wrapper).addClass('x-expanded');

        openWidget = false;

        if ($('.x-cart-list > ul', $wrapper).find('li').length > 3) {
            $('.x-cart-list > ul', $wrapper).slick('setPosition');
        }

        if (userTriggeredOpen && model && model.IsPartiallyLoaded) {
            Vendd.Cart.ClearClientModel();
            openWidget = true;
            wrapper.loading(true);

            var getCartModelOptions = {
                ignoreExternalModules: false
            };

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
        } else { 
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.CartWidget));
        }
    };

    wrapper.close = function () {
        $(".js-widget-trigger", $wrapper).removeClass('x-open');
        $(".js-widget-container", $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $(".js-widget-container", $wrapper).addClass('x-loading');
        } else {
            $(".js-widget-container", $wrapper).removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        if (window.B2BModel === undefined) return;
        _.extend(model, window.B2BModel);
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("cartWidget", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function (html) {
        $wrapper.html(html);

        var $list = $('.x-cart-list > ul', $wrapper);
        var $items = $('.cart-item', $list);

        var carouselCartOpts = {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            prevArrow: $('.x-cart-widget .nav-prev'),
            nextArrow: $('.x-cart-widget .nav-next')
        };

        if ($list.children().length > 3) {
            $list.slick(carouselCartOpts);
        }

        if (openWidget) {
            $('html, body').animate({ scrollTop: $wrapper.offset().top }, 600);
            wrapper.open();
        }

        wrapper.loading(false);

        formatPrices($wrapper);

        $('.js-expand-combo', $items).click(function () {
            $(this).closest('.cart-item').siblings().find('.combo-item-wrapper.expanded').removeClass('expanded open-above').children('.combo-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');

            if (!$(this).closest('.cart-item').next().hasClass('slick-active') && $items.length > 3) {
                $(this).parent().toggleClass('open-above');
            }

            $(this).parent().toggleClass('expanded');
            $(this).toggleClass('icon-arrow-down icon-arrow-up');
        });
    };

    $wrapper.on('click', '.js-remove', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $item = $this.closest('.cart-item');
        var id = $item.data('identifier');

        wrapper.loading(true);
        //wrapper.close();
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Remove(id));
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
    });

    if (isTouch()) {
        $wrapper.on('click', '.js-widget-trigger', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('x-open')) {
                wrapper.close();
            } else {
                wrapper.open(true);
            }
        });
    }
    else {
        var config = {
            sensitivity: 2,
            interval: 50,
            timeout: 200,
            over: function () {
                wrapper.open(true);
            },
            out: function () {
                wrapper.close();
            }
        };

        $wrapper.hoverIntent(config);
    }

    $wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', function (e) {
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.Cart;
        wrapper.extendModel();
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, wrapper, function (envelope) {
        if (envelope.message.data.success===false) {
            model.IsAddToCartAllowed = true;
            wrapper.extendModel();
            wrapper.update();
            wrapper.open();
        }
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, wrapper, function (envelope) {
        if (envelope.message.data.success === true) {
            model.HasValidationError = true;
            model.WarningMessage = envelope.message.data.data.Messages[0];
            wrapper.extendModel();
            wrapper.update();
            wrapper.open();
        }
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
    	if (envelope.message.data.widgetName !== Vendd.Widget.CartWidget) {
    		wrapper.close();
    	};
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.OpenWidget, wrapper, function (envelope) {
        if (envelope.message.data.widgetName === Vendd.Widget.CartWidget) {
            if (envelope.message.data.immediate === true) {
                wrapper.open(true);
            } else {
                openWidget = true; // the next refresh will open it
            };
        };
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {

        var isB2B = envelope.message.data.model.IsB2BUser;
        var isAuthenticated = envelope.message.data.model.IsAuthenticated

        if (isB2B && isAuthenticated && venddProjectConfigs.SiteIsLocked) {
            $wrapper.removeClass('site-is-locked');
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());
        }
    });
});
